<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pending"
        :save-button-disabled="pending"
        with-delete-button
        edit-mode
        @backBtnClicked="redirectToOverview"
        @primaryBtnClicked="saveExamResult"
        @deleteBtnClicked="deleteExamResult"
    >
        <h1 class="kgr-headline kgr-headline--h1 kgr-headline--text">
            {{ result.title }}
        </h1>
        <kgr-dog-exam-result-data-provider
            :dog-id="dogId"
            :exam-id="resultId"
            :callback="onExamLoaded"
        >
            <kgr-exam-result-form
                :exam-result="result"
                :error="error"
                @post-input="result = $event"
            />
        </kgr-dog-exam-result-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import DogExamResultDataProvider from '../../components/data-provider/DogExamResultDataProvider.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import Error from '../../js/model/Error.js';
import ExamResult from '../../js/dto/club/ExamResult.js';
import ExamResultForm from '../../components/exams/ExamResultForm.vue';
import FormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-exam-result-form': ExamResultForm,
        'kgr-dog-exam-result-data-provider': DogExamResultDataProvider,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
        resultId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            result: new ExamResult()
        };
    },
    mounted() {
        this.loadResult();
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onExamLoaded(result) {
            this.result = result;
        },
        saveExamResult() {
            this.pending = true;
            DogRepository.updateExamResult(this.dogId, this.result)
                .then(() => {
                    this.redirectToOverview();
                })
                .catch(error => {
                    this.error = error;
                    this.pending = false;
                });

        },
        deleteExamResult() {
            this.pending = true;
            DogRepository.deleteExamResult(this.dogId, this.result)
                .then(() => {
                    this.redirectToOverview();
                })
                .catch(error => {
                    this.error = error;
                    this.pending = false;
                });

        },
        loadResult() {
            this.pending = true;
            DogRepository.findExamResult(this.dogId, this.resultId)
                .then(result => {
                    this.result = result
                })
                .catch(error => {
                    this.error = error;
                })
                .finally(() => this.pending = false);

        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
